import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthContext } from '../contexts/AuthContext';

/**
 * allowedRoles: 許可するロールの配列
 * 例: ['superadmin'] / ['owner', 'staff'] / ['superadmin', 'owner', 'staff']
 */
const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, userProfile, loading } = useAuthContext();

  if (loading) {
    return (
      <div style={styles.loading}>
        <p>読み込み中...</p>
      </div>
    );
  }

  // 未ログイン
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // ロールチェック
  const normalizedRole = userProfile?.role?.trim()?.toLowerCase();
  
  if (allowedRoles && !allowedRoles.includes(normalizedRole)) {
    // ロールに応じて適切なページへリダイレクト
    if (['superadmin', 'owner', 'staff'].includes(normalizedRole)) {
      return <Navigate to="/dashboard" replace />;
    }
    if (normalizedRole === 'guest') {
      return <Navigate to="/portal" replace />;
    }
    return <Navigate to="/login" replace />;
  }

  // ライセンス状態チェック（ownerのみ）: status=inactive はブロック、期限切れは通過させてDashboard側で制限
  if (normalizedRole === 'owner') {
    const status = userProfile?.license?.status;
    if (status !== 'active') {
      return <Navigate to="/login" state={{ customError: 'アカウントが無効化されています。管理者にお問い合わせください。' }} replace />;
    }
  }

  return children;
};

const styles = {
  loading: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    color: '#999'
  }
};

export default ProtectedRoute;
